"use strict";
/* globals module */
/**
 * @module commerceLookupsCountryRoute
 * @description Baasic Commerce Lookups Country Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../../common");
;
var contracts_1 = require("../../../../core/contracts");
var __1 = require("../../");
var CommerceLookupsCountryStateRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCountryStateRoute, _super);
    function CommerceLookupsCountryStateRoute(commerceCountryStateBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceCountryStateBatchRoute = commerceCountryStateBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/states/{?countryId,searchQuery,page,rpp,sort,embed}';
        _this.getRoute = 'commerce/lookups/states/{id}/{?embed}';
        _this.createRoute = 'commerce/lookups/states';
        _this.updateRoute = 'commerce/lookups/states/{id}';
        _this.deleteRoute = 'commerce/lookups/states/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsCountryStateRoute.prototype, "batch", {
        get: function () {
            return this.commerceCountryStateBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce country state route which can be expanded with additional options. Supported items are:
     * - `countryId` - An identifier used to identify commerce country resource.
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsCountryStateRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsCountryStateRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get commerce country state route which can be expanded with additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsCountryStateRoute.get(id, options);
     **/
    CommerceLookupsCountryStateRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce country state route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryStateRoute.create();
     **/
    CommerceLookupsCountryStateRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce country state route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryStateRoute.update(data);
     **/
    CommerceLookupsCountryStateRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce country state route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryStateRoute.delete(data);
     **/
    CommerceLookupsCountryStateRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsCountryStateRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryStateBatchRoute !== "undefined" && __1.CommerceLookupsCountryStateBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsCountryStateRoute);
    return CommerceLookupsCountryStateRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCountryStateRoute = CommerceLookupsCountryStateRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
